import { http } from '@develop/ia-api-library'
import type { Environment } from '~/models/environment'

export default defineNuxtPlugin(async (nuxtApp) => {
  const { appEnv, cmsToken, fecApiKey, isProd } = useEnvs()
  http.options.setEnv(appEnv.value as Environment)
  http.options.setApiKey(fecApiKey.value)
  if (isProd.value) {
    http.options.setCMSToken(cmsToken.value)
  }

  // SSR Memory Leak Prevention: Clear any accumulated state after each SSR request
  // This is necessary because @develop/ia-api-library uses module-level singletons
  // that can accumulate data across SSR requests
  if (import.meta.server) {
    const clearEventBus = () => {
      const eventBus = http.events as unknown as { clear?: () => void; listeners?: Record<string, unknown[]> }
      if (eventBus) {
        if (typeof eventBus.clear === 'function') {
          eventBus.clear()
        } else if (eventBus.listeners && typeof eventBus.listeners === 'object') {
          for (const key of Object.keys(eventBus.listeners)) {
            eventBus.listeners[key] = []
          }
        }
      }
    }

    // Clean up after successful render
    nuxtApp.hook('app:rendered', clearEventBus)
    // Also clean up on error — if SSR fails mid-render
    nuxtApp.hook('app:error', clearEventBus)
  }
})
